/* global baseUrl, angular */

//<editor-fold defaultstate="collapsed" desc="imports">
"use strict";
import ngMaterialStyle from 'angular-material/angular-material.min.css'
import scrollBarlStyle from 'smooth-scrollbar/dist/smooth-scrollbar.css'
import style from '../less/style.less'
import angular from 'angular';
import ngSanitize from 'angular-sanitize';
import angularSpinner from 'angular-spinner';
import angularFileUpload from 'angular-file-upload';
import ngCookies from 'angular-cookies';
import ngMessages from 'angular-messages';
import ngAnimate from 'angular-animate';
import duScroll from 'angular-scroll';
import SmoothScrollbar from 'angular-smooth-scrollbar';
import ngMaterial from 'angular-material';
import jQuery from 'jquery'
import ngRoute from 'angular-route'
import ngStorage from 'ngstorage'
import vcRecaptcha from 'angular-recaptcha'
import i18n from 'angular-i18n/angular-locale_ru.js'
import uiMask  from 'angular-ui-mask'
import _ from 'lodash'
import vAccordion from 'v-accordion'
import vAccordionCss from 'v-accordion/dist/v-accordion.css'
import AngularUtilsPagination from 'angular-utils-pagination'
import uiSwiper from 'angular-ui-swiper'
import uiSwiperCss from 'angular-ui-swiper/dist/angular-ui-swiper.css'
import moment from 'moment'
// import firebase from "firebase/app";
        window.jQuery = jQuery;
//</editor-fold>

(function () {
    /mobi/i.test(navigator.userAgent) && !location.hash && setTimeout(function () {
        if (!pageYOffset)
            window.scrollTo(0, 1);
    }, 1000);

    //<editor-fold desc="hash">
    try {
        var scripts = document.getElementsByTagName('script');
        var index = scripts.length - 1;
        var myScript = scripts[index];
        global.hash = myScript.getAttribute("src").substr(myScript.getAttribute("src").indexOf("?") + 1);
    } catch (e) {
        global.hash = Math.random();
    }
    //</editor-fold>

    //<editor-fold desc="serviceWorker">
    window.sw = new Promise(function (resolve, reject) {
        //alert((17)
        if ('serviceWorker' in navigator) {
            //alert((18)
            window.addEventListener('load', () => {
                //alert((19)
                navigator.serviceWorker.register('/sw.js')
                        .then(function (registration) {
                            // //alert((20)
                            console.log("Service Worker Registered", registration);
                            resolve(registration);
                            // return registration;
                            window.initFirebaseApp();
                        }).catch(function (e) {
                    // //alert((21)
                    console.log(e);
                    console.log("Service Worker Registration Failed");
                    try {
                        reject();
                    } catch (e) {
                    }
                });
                setTimeout(function () {
                    reject();
                }, 5000);
            });
        } else {
            //alert((24);
            reject();
        }
    });
    //</editor-fold>

    //<editor-fold defaultstate="collapsed" desc="modules">
    angular.module('app', [
        'ngSanitize'
                , 'angularSpinner'
                , 'angularFileUpload'
                , 'ngCookies'
                , 'ngMessages'
                , 'ngRoute'
                , 'ngAnimate'
                , 'ngMaterial'
                , 'duScroll'
                , 'ngStorage'
                , 'ui.mask'
                , 'SmoothScrollbar'
                , 'vcRecaptcha'
                , 'vAccordion'
                , 'angularUtils.directives.dirPagination'
                , 'ui.swiper'
    ])
            //<editor-fold defaultstate="collapsed" desc="config">
            .config(['$httpProvider'
                        , 'ScrollbarServiceProvider'
                        , '$routeProvider'
                        , '$locationProvider'
                        , '$mdAriaProvider'
                        , 'uiMask.ConfigProvider'
                        , 'vcRecaptchaServiceProvider'
                        , function ($httpProvider, ScrollbarServiceProvider, $routeProvider, $locationProvider, $mdAriaProvider, uiMaskConfigProvider
                                , vcRecaptchaServiceProvider) {
                            //<editor-fold defaultstate="collapsed" desc="configHeader">
                            ScrollbarServiceProvider.setDefaultOptions(
                                    {
                                        alwaysShowTracks: true
                                        , syncCallbacks: true
                                        , wheelEventTarget: 'body'
                                    });

                            var spinner = 0;
                            uiMaskConfigProvider.clearOnBlur(false);
                            uiMaskConfigProvider.addDefaultPlaceholder(false);
                            $locationProvider.html5Mode(true);
                            //</editor-fold>
                            $mdAriaProvider.disableWarnings();
                            vcRecaptchaServiceProvider.setSiteKey('6LeB9c8ZAAAAAEoFuRBcDeV3Bc2ZSNYkEUr6kvQq');
                            $routeProvider
                                    .when('/feedback.html', {
                                        templateUrl: 'tmpl/open/feedback.html' + '?' + hash,
                                        controller: 'FeedbackCtrl',
                                        controllerAs: 'FeedbackCtrl'
                                    }).when('/success_feedback.html', {
                                templateUrl: 'tmpl/open/success_feedback.html' + '?' + hash
                            })
                            // .otherwise({
                            //     templateUrl: 'tmpl/open/start.html',
                            //     controller: 'StartCtrl',
                            //     controllerAs: 'StartCtrl'
                            // });
                            //<editor-fold defaultstate="collapsed" desc="spinner">
                            $httpProvider.interceptors.push(["$q", "usSpinnerService", function ($q, usSpinnerService) {
                                    return {
                                        'request': function (config) {
                                            usSpinnerService.spin('spinner-1');
                                            spinner++;
                                            return config;
                                        },
                                        'response': function (response) {
                                            spinner--;
                                            if (spinner === 0) {
                                                usSpinnerService.stop('spinner-1');
                                            }
                                            return response;
                                        },
                                        'responseError': function (response) {
                                            spinner--;
                                            if (spinner === 0) {
                                                usSpinnerService.stop('spinner-1');
                                            }
                                            return response;
                                        }
                                    };
                                }]);
                            $httpProvider.defaults.cache = false;
                            $httpProvider.defaults.headers.common["X-Requested-With"] = 'XMLHttpRequest';
                            //</editor-fold>
                        }
            ]
                    )
            //</editor-fold>
            //<editor-fold defaultstate="collapsed" desc="run">
            .run(['$http', '$window', '$document', '$rootScope', '$localStorage', '$location', 'ScrollbarService', "$timeout", "$cookies", "$mdDialog",
                function ($http, $window, $document, $rootScope, $localStorage, $location, ScrollbarService, $timeout, $cookies, $mdDialog) {
                    $http.defaults.headers.common["X-Requested-With"] = 'XMLHttpRequest';
                    ScrollbarService.getInstance("contentScroolbar").then(function (scroll) {
                        global.contentScroll = scroll;
                        window.addEventListener("wheel", scrollEvent);
                        function scrollEvent(event) {
                            // event.preventDefault();
                            event.stopImmediatePropagation()
                            for (let i = 0; i < event.path.length; i++) {
                                let path = event.path[i];
                                if (path == contentScroll.targets.container) {
                                    return null;
                                }
                            }
                            contentScroll.scrollTo(0, contentScroll.scrollTop + event.deltaY, 300);
                            // console.log(event)
                            return false;
                        }
                    });
                    global.contentScroll = undefined;
                    // global.contentScroll=Scrollbar.get(document.querySelector("#contentScroolbar"),{});
                    $rootScope.logout = function () {
                        $http.get(baseUrl + "/json/form/logout.json").then(function () {
                            window.location.href = "/";
//                            $timeout(function () {
                            window.location.reload();
//                            }, 300);
                        });
                    };
                    $rootScope.programs = function () {
                        $http.post(baseUrl + "/json/form/clearCurrentProgram").then(function () {
                            window.location.href = "/programs.html";
                        });
                    };
                    $rootScope.showNotify = function (title, body, link) {
                        $timeout(function () {
                            $rootScope.notify = {
                                title: title,
                                body: body,
                                link: link
                            }
                        }, 10);
                    }
                    $rootScope.closeNotify = function () {
                        $timeout(function () {
                            $rootScope.notify = undefined;
                        }, 100);
                    }
                    // if (angular.isDefined($localStorage.route) && $localStorage.route !== ''&&($localStorage.route=="/lk.html")) {
                    //     $location.url($localStorage.route);
                    // }
                    $rootScope.$on('$viewContentLoaded', function () {
                        if (angular.isDefined(contentScroll)) {
                            $timeout(function () {
                                contentScroll.update();
                                contentScroll.scrollTo(0, 0);
                            }, 50);
                        }
                    })
                    $rootScope.$on('$routeChangeSuccess', function () {
                        $localStorage.route = $location.url();
                        if ($rootScope.user && $rootScope.user.is_agree_rules && ($location.url() === "/start.html" || $location.url() === "/" || $location.url() === "/login.html")) {
                            $localStorage.route = "/lk.html";
                            $location.url($localStorage.route);
                        }
                    });
                    if (document.getElementsByClassName("isMobile").length > 0
                            && !$localStorage.onMainScreen
                            && !$cookies.get("blockA2HS")) {
                        window.addEventListener('beforeinstallprompt', (e) => {
                            // Prevent Chrome 67 and earlier from automatically showing the prompt
                            e.preventDefault();
                            // Stash the event so it can be triggered later.
                            window.deferredPrompt = e;
                            var confirm = $mdDialog.confirm()
                                    .title('Добавить ярлык на главный экран?')
                                    .htmlContent('<img class="img" alt=""  src="/images/icons/apple-icon-57x57.png">Иконка будет размещена на экране Вашего телефона для быстрого доступа к программе Profitire.')
                                    .ariaLabel('Add to home screen')
                                    .ok('Добавить')
                                    .cancel('Отмена')
                                    .theme("toMainScreen");
                            $mdDialog.show(confirm).then(function () {
                                window.deferredPrompt.prompt();
                                window.deferredPrompt.userChoice.then((choiceResult) => {
                                    if (choiceResult.outcome === 'accepted') {
                                        $localStorage.onMainScreen = true;
                                    } else {
                                        $localStorage.onMainScreen = false;
                                        let now = new Date();
                                        now.setDate(now.getDate() + 7);
                                        $cookies.put("blockA2HS", true, {expires: now});
                                    }
                                    window.deferredPrompt = null;
                                });
                            }, function () {
                                let now = new Date();
                                now.setDate(now.getDate() + 7);
                                $cookies.put("blockA2HS", true, {expires: now});
                                $localStorage.onMainScreen = false;
                            });
                        });
                    }
                }]);
    //</editor-fold>
    //</editor-fold>

    //<editor-fold defaultstate="collapsed" desc="FeedbackCtrl">
    angular.module('app').controller('FeedbackCtrl', ['$scope', '$http', '$rootScope', 'FileUploader', '$timeout', '$location',
        function ($scope, $http, $rootScope, FileUploader, $timeout, $location) {
            $scope.Math = Math;
            $scope.user = {
                email: $rootScope.user ? $rootScope.user.email : ''
            };
            $scope.send = function () {
                if ($scope.feedbackFrom.$invalid) {
                    $scope.feedbackFrom.$setDirty();
                    angular.forEach($scope.feedbackFrom.$error.required, function (field) {
                        field.$setDirty(true);
                    });
                } else {
                    $http.post(baseUrl + "/json/feedback/send", $scope.user).then(function (response) {
                        if (response.data.result === 1 || response.data.result === "1") {
                            $location.path("/success_feedback.html");
                        } else {
                            $scope.error = response.data.msg;
                        }
                    });
                }
            };
        }]);
    //</editor-fold>

    //<editor-fold defaultstate="collapsed" desc="WinnerCtrl">
    angular.module('app').controller('WinnerCtrl', ['$scope', '$http', '$rootScope', '$timeout',
        function ($scope, $http, $rootScope, $timeout) {
//                    $http.post(baseUrl + "json/get/winner", $scope.search).then(function (response) {
//                        $scope.winners = response.data;
//                    });
//                    $scope.currentPage = 1;
//                    $scope.itemsPerPage = 5;
//                    $scope.textMaskConfig = {
//                        guide: true,
//                        mask: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
//                    };
//                    $scope.send = function () {
//                        $http.post(baseUrl + "json/get/winner", $scope.search).then(function (response) {
//                            $scope.winners = response.data;
//                        });
//                    };
//                    $scope.back = function () {
//                        delete $scope.error;
//                    };
        }]);
    //</editor-fold>

    //<editor-fold defaultstate="collapsed" desc="getter">
    angular.module('app').service('getter', ['$q', '$http', '$timeout',
        function ($q, $http, $timeout) {
            var results = {};
            var getpointlistTime = 0;
            var timeoutGetPointDelay = 0;
            var getterService = {
                getUserInfo: function () {
                    var promise = $q.defer();
                    if (!results['userInfo']) {
                        // $http returns a promise, which has a then function, which also returns a promise
                        $http.get(baseUrl + "/json/form/getProfile").then(function (response) {
                            // debugger
                            promise.resolve(response.data);
                        }, function () {
                            promise.reject();
                        });
                        results['userInfo'] = promise.promise;
                    }
                    return results['userInfo'];
                },
                getActions: function () {
                    var promise = $q.defer();
                    if (!results['getActions']) {
                        // $http returns a promise, which has a then function, which also returns a promise
                        $http.get(baseUrl + "/json/get/getActions").then(function (response) {
                            // debugger
                            promise.resolve(response.data);
                        }, function () {
                            promise.reject();
                        });
                        results['getActions'] = promise.promise;
                    }
                    return results['getActions'];
                },
                getStatistic: function (year) {
                    var promise = $q.defer();
                    // if (!results['getStatistic']) {
                    // $http returns a promise, which has a then function, which also returns a promise
                    $http.get(baseUrl + "/json/get/stats?year=" + (year || 2023)).then(function (response) {
                        // debugger
                        response.data.ball =
                                (response.data.countCheckBall || 0)
                                + (response.data.countExtraBall || 0)
                                + (response.data.countLearnBall || 0)
                                - (response.data.prizeBall || 0);

                        promise.resolve(response.data);
                    }, function () {
                        promise.reject();
                    });
                    // results['getStatistic'] = promise.promise;
                    return promise.promise;
                    // }
                    // return results['getStatistic'];
                },
                getRegions: function () {
//                    usSpinnerService.spin();
                    var promise = $q.defer();
                    if (!results['getRegions']) {
                        // $http returns a promise, which has a then function, which also returns a promise
                        $http.get(baseUrl + "/json/get/getRegions").then(function (response) {
                            // debugger
                            promise.resolve(response.data);
                        }, function () {
                            promise.reject();
                        });
                        results['getRegions'] = promise.promise;
                    }
                    return results['getRegions'];
                },
                getRegionsKladr: function () {
//                    usSpinnerService.spin();
                    var promise = $q.defer();
                    if (!results['getRegions']) {
                        // $http returns a promise, which has a then function, which also returns a promise
                        $http.get(baseUrl + "/json/get/getRegionsKladr").then(function (response) {
                            // debugger
                            promise.resolve(response.data);
                        }, function () {
                            promise.reject();
                        });
                        results['getRegions'] = promise.promise;
                    }
                    return results['getRegions'];
                }
                , getCitys: function (region) {
//                    usSpinnerService.spin();
                    var promise = $q.defer();
                    if (!results['getCitys' + region]) {
                        // $http returns a promise, which has a then function, which also returns a promise
                        $http.get(baseUrl + "/json/get/getCityKLADR/" + region).then(function (response) {
                            promise.resolve(response.data);
                        }, function () {
                            promise.reject();
                        });
                        results['getCitys' + region] = promise.promise;
                    }
                    return results['getCitys' + region];
                }
                , getRegionsDealers: function () {
//                    usSpinnerService.spin();
                    var promise = $q.defer();
                    if (!results['getRegionsDealers']) {
                        // $http returns a promise, which has a then function, which also returns a promise
                        $http.get(baseUrl + "/json/get/getRegionsDealers").then(function (response) {
                            // debugger
                            promise.resolve(response.data);
                        }, function () {
                            promise.reject();
                        });
                        results['getRegionsDealers'] = promise.promise;
                    }
                    return results['getRegionsDealers'];
                }
                , getPrizes: function () {
//                    usSpinnerService.spin();
                    var promise = $q.defer();
                    if (!results['getPrizes']) {
                        // $http returns a promise, which has a then function, which also returns a promise
                        $http.get(baseUrl + "/json/get/prizes").then(function (response) {
                            // debugger
                            promise.resolve(response.data);
                        }, function () {
                            promise.reject();
                        });
                        results['getPrizes'] = promise.promise;
                    }
                    return results['getPrizes'];
                }
                , getDealers: function (region) {
//                    usSpinnerService.spin();
                    var promise = $q.defer();
                    if (!results['getDealers' + region]) {
                        // $http returns a promise, which has a then function, which also returns a promise
                        $http.post(baseUrl + "/json/get/getDealers", {region: region}).then(function (response) {
                            promise.resolve(response.data);
                        }, function () {
                            promise.reject();
                        });
                        results['getDealers' + region] = promise.promise;
                    }
                    return results['getDealers' + region];
                }
                , getNPs: function (id) {
//                    usSpinnerService.spin();
                    var promise = $q.defer();
                    if (!results['getNPs']) {
                        // $http returns a promise, which has a then function, which also returns a promise
                        $http.get(baseUrl + "/json/get/getNPs/" + id).then(function (response) {
                            promise.resolve(response.data);
                        }, function () {
                            promise.reject();
                        });
                        results['getNPs'] = promise.promise;
                    }
                    return results['getNPs'];
                }
                , getByePointListByCityName: function (name) {
//                    usSpinnerService.spin();
                    var promise = $q.defer();
                    if (!results['getByePointListByCityName' + name]) {
                        // $http returns a promise, which has a then function, which also returns a promise
                        $http.post(baseUrl + "json/get/byepoint_citys_name", name).then(function (response) {
                            promise.resolve(response.data);
                        }, function () {
                            promise.reject();
                        });
                        results['getByePointListByCityName' + name] = promise.promise;
                    }
                    return results['getByePointListByCityName' + name];
                }
                , getByePointList: function () {
                    var promise = $q.defer();
                    if (!results['getByePointList']) {
                        // $http returns a promise, which has a then function, which also returns a promise
                        $http.get("json/get/byepoint").then(function (response) {
                            promise.resolve(response.data);
                        }, function () {
                            promise.reject();
                        });
                        results['getByePointList'] = promise.promise;
                    }
                    return results['getByePointList'];
                }
                , getByePointListCords: function (x1, y1, x2, y2) {
                    var promise = $q.defer();
                    // $http returns a promise, which has a then function, which also returns a promise
//                            debugger;
                    var dr = new Date().getTime();
                    if (getpointlistTime + 1000 < dr) {
                        getpointlistTime = dr;
                        $http.get("json/get/byepoint/" + x1 + "/" + y1 + "/" + x2 + "/" + y2).then(function (response) {
                            promise.resolve(response.data);
                        }, function () {
                            promise.reject();
                        });
                    } else {
                        if (timeoutGetPointDelay != 0) {
                            $timeout.cancel(timeoutGetPointDelay);
                        }
                        timeoutGetPointDelay = $timeout(function () {
                            $http.get("json/get/byepoint/" + x1 + "/" + y1 + "/" + x2 + "/" + y2).then(function (response) {
                                promise.resolve(response.data);
                            }, function () {
                                promise.reject();
                            });
                        }, 1000);
                    }
                    results['getByePointList'] = promise.promise;
                    return results['getByePointList'];
                }
                , getByeRegions: function () {
                    var promise = $q.defer();
                    // $http returns a promise, which has a then function, which also returns a promise
                    $http.get("json/get/byepoint_regions").then(function (response) {
                        promise.resolve(response.data);
                    }, function () {
                        promise.reject();
                    });
                    results['getByeRegions'] = promise.promise;
                    return results['getByeRegions'];
                }
                , getByeCitys: function (id) {
                    var promise = $q.defer();
                    // $http returns a promise, which has a then function, which also returns a promise
                    $http.get("json/get/byepoint_citys/" + id).then(function (response) {
                        promise.resolve(response.data);
                    }, function () {
                        promise.reject();
                    });
                    results['getByeCitys'] = promise.promise;
                    return results['getByeCitys'];
                }
                , getByePoints: function (id) {
                    var promise = $q.defer();
                    // $http returns a promise, which has a then function, which also returns a promise
                    $http.get("json/get/byepoint_popints/" + id).then(function (response) {
                        promise.resolve(response.data);
                    }, function () {
                        promise.reject();
                    });
                    results['getByePoints'] = promise.promise;
                    return results['getByePoints'];
                }
                , getСurrentProgram: function () {
                    var promise = $q.defer();
                    // $http returns a promise, which has a then function, which also returns a promise
                    $http.get("/json/get/currentProgram").then(function (response) {
                        promise.resolve(response.data);
                    }, function () {
                        promise.reject();
                    });
                    return promise.promise;
                }
            };
            return getterService;
        }]);
    //</editor-fold>

    //<editor-fold defaultstate="collapsed" desc="inputDirectives">
    angular.module('app').directive("russianOnly", function () {

        return {
            require: 'ngModel',
            link: function (scope, element, attr, ngModelCtrl) {
                var keyCode = [50];
                element.bind("keydown", function (event) {
                    // console.log(event);
                    if (jQuery.inArray(event.which, keyCode) > -1
                            || event.key === "«"
                            || event.key === "»"
                            ) {
                        scope.$apply(function () {
                            // scope.$eval(attrs.onlyNum);
                            event.preventDefault();
                        });
                        event.preventDefault();
                    }

                });

                function fromUser(text) {
                    var usKey = {
                        'z': 'я',
                        'x': 'ч',
                        'c': 'с',
                        'v': 'м',
                        'b': 'и',
                        'n': 'т',
                        'm': 'ь',
                        ',': 'б',
                        '.': 'ю',
                        'a': 'ф',
                        's': 'ы',
                        'd': 'в',
                        'f': 'а',
                        'g': 'п',
                        'h': 'р',
                        'j': 'о',
                        'k': 'л',
                        'l': 'д',
                        ';': 'ж',
                        '\'': 'э',
                        'q': 'й',
                        'w': 'ц',
                        'e': 'у',
                        'r': 'к',
                        't': 'е',
                        'y': 'н',
                        'u': 'г',
                        'i': 'ш',
                        'o': 'щ',
                        'p': 'з',
                        '[': 'х',
                        ']': 'ъ',
                        '`': 'ё',
                        'Z': 'Я',
                        'X': 'Ч',
                        'C': 'С',
                        'V': 'М',
                        'B': 'И',
                        'N': 'Т',
                        'M': 'Ь',
                        '<': 'Б',
                        '>': 'Ю',
                        'A': 'Ф',
                        'S': 'Ы',
                        'D': 'В',
                        'F': 'А',
                        'G': 'П',
                        'H': 'Р',
                        'J': 'О',
                        'K': 'Л',
                        'L': 'Д',
                        ':': 'Ж',
                        '"': 'Э',
                        'Q': 'Й',
                        'W': 'Ц',
                        'E': 'У',
                        'R': 'К',
                        'T': 'Е',
                        'Y': 'Н',
                        'U': 'Г',
                        'I': 'Ш',
                        'O': 'Щ',
                        'P': 'З',
                        '{': 'Х',
                        '}': 'Ъ',
                        '»': '',
                        '«': '',
                        '~': 'Ё'
                    };
                    var transformedInput = text.replace(/./g, function (c) {
                        return c in usKey ? usKey[c] : c
                    });
                    if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput; // or return Number(transformedInput)
                }

                ngModelCtrl.$parsers.push(fromUser);
            }

        };
    });
    angular.module('app').directive("alphbetOnly", function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attr, ngModelCtrl) {
                function fromUser(text) {
                    var usKey = {
                        '1': '',
                        '2': '',
                        '3': '',
                        '4': '',
                        '5': '',
                        '6': '',
                        '7': '',
                        '8': '',
                        '9': '',
                        '0': ''
                    };
                    var transformedInput = text.replace(/./g, function (c) {
                        return c in usKey ? usKey[c] : c
                    });
                    if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput; // or return Number(transformedInput)
                }

                ngModelCtrl.$parsers.push(fromUser);
            }
        };
    });
    angular.module('app').directive("englishOnly", function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attr, ngModelCtrl) {
                function fromUser(text) {
                    if (angular.isDefined(text)) {
                        var usKey = {
                            'я': 'z',
                            'ч': 'x',
                            'с': 'c',
                            'м': 'v',
                            'и': 'b',
                            'т': 'n',
                            'ь': 'm',
                            'б': ',',
                            'ю': '.',
                            'ф': 'a',
                            'ы': 's',
                            'в': 'd',
                            'а': 'f',
                            'п': 'g',
                            'р': 'h',
                            'о': 'j',
                            'л': 'k',
                            'д': 'l',
                            'ж': ';',
                            'э': '\'',
                            'й': 'q',
                            'ц': 'w',
                            'у': 'e',
                            'к': 'r',
                            'е': 't',
                            'н': 'y',
                            'г': 'u',
                            'ш': 'i',
                            'щ': 'o',
                            'з': 'p',
                            'х': '[',
                            'ъ': ']',
                            'ё': '`',
                            'Я': 'Z',
                            'Ч': 'X',
                            'С': 'C',
                            'М': 'V',
                            'И': 'B',
                            'Т': 'N',
                            'Ь': 'M',
                            'Б': '<',
                            'Ю': '>',
                            'Ф': 'A',
                            'Ы': 'S',
                            'В': 'D',
                            'А': 'F',
                            'П': 'G',
                            'Р': 'H',
                            'О': 'J',
                            'Л': 'K',
                            'Д': 'L',
                            'Ж': ':',
                            'Э': '"',
                            'Й': 'Q',
                            'Ц': 'W',
                            'У': 'E',
                            'К': 'R',
                            'Е': 'T',
                            'Н': 'Y',
                            'Г': 'U',
                            'Ш': 'I',
                            'Щ': 'O',
                            'З': 'P',
                            'Х': '{',
                            'Ъ': '}',
                            'Ё': '~',
                            '"': '@'
                        };
                        let transformedInput = text.replace(/./g, function (c) {
                            //  console.log(c);
                            return c in usKey ? usKey[c] : c
                        });
                        if (transformedInput !== text) {
                            ngModelCtrl.$setViewValue(transformedInput);
                            ngModelCtrl.$render();
                        }
                        return transformedInput; // or return Number(transformedInput)
                    } else {
                        return text;
                    }
                }

                ngModelCtrl.$parsers.push(fromUser);
            }
        };
    });
    angular.module('app').directive('numberOnly', function () {
        return function (scope, element, attrs) {

            var keyCode = [35, 36, 46, 45, 86, 8, 9, 37, 39, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 110];
            element.bind("keydown", function (event) {
                //console.log(event);
                if (jQuery.inArray(event.which, keyCode) === -1) {
                    scope.$apply(function () {
                        scope.$eval(attrs.onlyNum);
                        event.preventDefault();
                    });
                    event.preventDefault();
                }

            });
        };
    });
    angular.module('app').directive('passwordInput', function () {
        return function (scope, element, attrs) {

            var keyCode = [35, 36, 46, 45, 86, 8, 9, 37, 39, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 110];
            element.bind("keydown", function (event) {
//                console.log(event);
                if ($.inArray(event.which, keyCode) === -1) {
                    scope.$apply(function () {
                        scope.$eval(attrs.onlyNum);
                        event.preventDefault();
                    });
                    event.preventDefault();
                }

            });
        };
    });
    angular.module('app').filter('range', function () {
        return function (input, total) {
            total = parseInt(total);
            for (var i = 0; i < total; ++i) {
                input.push(i);
            }
            return input;
        };
    });
    angular.module('app').directive('ngEnter', function () {
        return function (scope, element) {
            element.bind("keydown keypress", function (event) {
//                debugger;
                if (event.which === 13) {
                    $(element).closest('form').submit();
                }
            });
        };
    });
    angular.module('app').filter('filtr', ['$filter', '$sce', function ($filter, $sce) {
            return function (item, type) {
                if (type === 'date') {
                    return $sce.trustAsHtml(moment(item).format('DD.MM.Y'));
                } else if (type === 'datetime') {
                    return $sce.trustAsHtml($filter('date')(item, 'dd.MM.yyyy HH:mm:ss'));
                } else if (type === 'phone') {
                    if (item !== 'Нет') {
                        var regexObj = /^(?:\+?7[-.]?)?(?:\(?([0-9]{3})\)?[-. ]?)?([0-9]{3})[-. ]?([0-9]{2})([0-9]{2})$/;
                        if (regexObj.test(item)) {
                            var parts = (item + "").match(regexObj);
                            var phone = "";
                            if (parts[1]) {
                                phone += "<noskype>+7&nbsp;(" + parts[1] + ")&nbsp;";
                            }
                            phone += parts[2] + "&#8209;" + parts[3] + "&#8209;" + parts[4] + "</noskype>";
                            return $sce.trustAsHtml(phone);
                        } else {
                            //invalid phonenumber
                            return $sce.trustAsHtml(item);
                        }
                    }
                } else if (type === "yn") {
                    switch (item) {
                        case 'Y':
                        case 'Да':
                        case 'да':
                            return $sce.trustAsHtml("<span class='i-yes'></span> Да");
                        case 'N':
                        case 'Нет':
                        case 'нет':
                            return $sce.trustAsHtml("<span class='i-no'></span> Нет");
                    }
                } else if (type === "sex") {
                    switch (item) {
                        case 1:
                            return $sce.trustAsHtml("Мужской");
                        case 0:
                            return $sce.trustAsHtml("Женский");
                    }
                }
                if (item === null) {
                    return $sce.trustAsHtml("");
                }
                return $sce.trustAsHtml("" + item);
            };
        }]);

    angular.module('app').directive('onFinishRender', function ($rootScope) {
        return {
            restrict: 'A',
            link: function (scope) {
                if (scope.$last) {
                    $rootScope.$broadcast("ngRepeatFinished", {temp: "some value"});
                }
            }
        };
    });

//    angular.module('app').directive('renderHtml', ['$compile', function ($compile) {
//            return {
//                restrict: 'A',
//                scope: {
//                    html: '='
//                },
//                link: function (scope, element, attrs) {
//                    function appendHtml() {
//                        if (scope.html) {
//                            var newElement = angular.element(scope.html);
//                            $compile(newElement)(scope);
//                            element.append(newElement);
//                        }
//                    }
//                    scope.$watch(function () {
//                        return scope.html
//                    }, appendHtml);
//                }
//            };
//        }]);
//
//    angular.module('app').directive('inputValueModel',['$filter', function ($filter) {
//            return {
//                restrict: 'A',
//                require: 'ngModel',
//                scope: {
//                    inputValue: '=ngModel'
//                },
//                link: function (scope, element, attrs, ngModelCtrl) {
//                    // update $viewValue on model change
//                    scope.$watch('inputValue', function () {
//                        ngModelCtrl.$setViewValue(scope.inputValue);
//                        ngModelCtrl.$render();
//                    });
//                    // $viewValue back to model
//                    ngModelCtrl.$parsers.push(function (viewValue) {
//                        var n = viewValue;
//                        return n;
//                    });
//                    // render $viewValue through filter
//                    ngModelCtrl.$render = function () {
//                        element.find('input').val(ngModelCtrl.$viewValue);
//                    };
//                }
//            };
//        }]);
    //</editor-fold>

}).call(this);

let promiseSW;
window.initFirebaseApp = function () {
    //alert((12)
    promiseSW = new Promise(function (resolve, reject) {
        //alert((13)
        try {
            console.log(window.sw)
            window.sw.then(function (sw) {
                //alert((14)
                debugger;
                if (firebase && firebase.apps && firebase.apps.length === 0) {
                    //alert((15)
                    var firebaseConfig = {
                        apiKey: "AIzaSyAEc1K4leI7MTjzUxzjLp5hwZLx79idUmo",
                        authDomain: "contiprofi-cc6f7.firebaseapp.com",
                        projectId: "contiprofi-cc6f7",
                        storageBucket: "contiprofi-cc6f7.appspot.com",
                        messagingSenderId: "461620387432",
                        appId: "1:461620387432:web:ac86a541b59b928bc465dd"
                    };
                    // Initialize Firebase
                    firebase.initializeApp(firebaseConfig);
                    window.messaging = firebase.messaging();
                    messaging.useServiceWorker(sw);
                    messaging.usePublicVapidKey("BPh4eXMkjT9EhBW7d-RBEW4DEvj4eIXrKK1l9XiNiwaGjhF5jekuk26LaxsCLwMR9YTsrHclnU8ByRwLpJi8gZo");
                    messaging.onMessage((payload) => {
                        console.log('Message received. ', payload);
                        // window.location.href=payload.notification.actions[0].action;
                        showNotify(payload.notification.title, payload.notification.body, payload.notification.actions[0].action);
                    });
                    resolve(messaging);
                    return sw;
                } else {
                    //alert((16)
                    if (firebase && firebase.apps) {
                        window.messaging = firebase.messaging();
                        // messaging.useServiceWorker(sw);
                        // messaging.usePublicVapidKey("BPh4eXMkjT9EhBW7d-RBEW4DEvj4eIXrKK1l9XiNiwaGjhF5jekuk26LaxsCLwMR9YTsrHclnU8ByRwLpJi8gZo");
                        messaging.onMessage((payload) => {
                            console.log('Message received. ', payload);
                            showNotify(payload.notification.title, payload.notification.body, payload.notification.actions[0].action);
                        });
                        resolve(messaging);
                        return sw;
                    }
                    reject();
                    return sw;
                }
            }, function (sw) {
                //alert((27);
                reject();
                return sw;
            }).catch(function (sw) {
                //alert((23)
                // debugger;
                reject();
                return sw;
            });
        } catch (e) {
            reject();
        }
    });
    return promiseSW;
}

// window.onMessage(function (e) {
//     alert(e);
// })

window.subscribeNotification = function (callback, failback) {
    //alert((1)
    window.initFirebaseApp().then(function (messaging) {
        let permission;
        try {
            // alert(2)
            if (Notification) {
                // alert(3)
                permission = Notification.requestPermission();
            } else {
                // alert(4)
                permission = messaging.requestPermission();
            }
            //alert((5)
            permission.then(function () {
                // alert(6)
                console.log('Permision Geeter');
                return messaging.getToken();
            })
                    .then(function (token) {
                        //alert((7)
                        console.log(token)
                        // alert(8)
                        if (angular.isDefined(callback)) {
                            callback(token);
                        }
                    })
                    .catch(function () {
                        // alert(9)
                        if (angular.isDefined(callback)) {
                            callback();
                        }
                    });
            if (angular.isDefined(failback)) {
                setTimeout(function () {
                    failback();
                }, 30 * 1000);
            }
        } catch (e) {
            // alert(10)
            if (angular.isDefined(callback)) {
                callback();
            }
        }
    }).catch(function () {
        // alert(11)
        if (angular.isDefined(callback)) {
            callback();
        }
        if (angular.isDefined(failback)) {
            failback();
        }
    });
};

//var _map;
jQuery.fn.extend({
    getMaxZ: function () {
        return Math.max.apply(null, jQuery(this).map(function () {
            var z;
            return isNaN(z = parseInt(jQuery(this).css("z-index"), 10)) ? 0 : z;
        }));
    }
});

Date.prototype.toJSON = function () {
    var timezoneOffsetInHours = -(this.getTimezoneOffset() / 60); //UTC minus local time
    var sign = timezoneOffsetInHours >= 0 ? '+' : '-';
    var leadingZero = (timezoneOffsetInHours < 10) ? '0' : '';
    //It's a bit unfortunate that we need to construct a new Date instance 
    //(we don't want _this_ Date instance to be modified)
    var correctedDate = new Date(this.getFullYear(), this.getMonth(),
            this.getDate(), this.getHours(), this.getMinutes(), this.getSeconds(),
            this.getMilliseconds());
    correctedDate.setHours(this.getHours() + timezoneOffsetInHours);
    var iso = moment(correctedDate).format("YYYY-MM-DD");//.toISOString().replace('Z', '').replace('T', ' ').substring(19, 0);

    return iso; //+ sign + leadingZero + Math.abs(timezoneOffsetInHours).toString() + ':00';
};

window.enforceMaxFileSize = {
    'name': 'enforceMaxFileSize',
    'fn': function (item) {
        if (item.size > 1048576 * 15) {
            $scope.error = "Слишком большой файл!<br>Формат файла: .JPG, .JPEG, .BMP, PDF, .PNG. Размер по высоте и ширине: до 4048px. Размер загружаемого фото не более 15 МБ";
            return false;
        }
        return true; // 1024 * 1024 | Math.pow(2,20); | 0x100000
    }
};

global.showNotify = function (title, body, link) {
    angular.element(document.querySelector('html')).injector().get('$rootScope').showNotify(title, body, link);
};

if (window.localStorage.getItem('cookieAgreement') == undefined) {
    jQuery('.coockiePopup').css('display', 'flex');
}

jQuery('.coockiePopup__buttons_button-accept').on('click', function () {
    window.localStorage.setItem('cookieAgreement', 'false');
    jQuery('.coockiePopup').hide();
})

jQuery('.coockiePopup__buttons_button-decline').on('click', function () {
    window.localStorage.removeItem('cookieAgreement');
    jQuery('.coockiePopup').hide();
})